import './timeStamp.scss';

export const TimeStampTemplate = (model) => {
	/* html */
	const html = `
        ${model.value}
    `;

	return html;
};
